import React from 'react';
import PropTypes from 'prop-types';
import { Converter } from 'showdown';

export function HTMLContent({ content, className }) {
  /* eslint-disable-next-line react/no-danger */
  return <div className={className} dangerouslySetInnerHTML={{ __html: content }} />;
}

HTMLContent.propTypes = {
  content: PropTypes.node,
  className: PropTypes.string,
};

HTMLContent.defaultProps = {
  content: null,
  className: '',
};

const classMap = {
  h1: 'mt-16 text-3xl font-bold text-center',
  h2: 'mt-8 text-2xl text-center',
  h3: 'mt-4 text-xl font-bold text-center',
  h4: 'mt-2 font-bold text-center',
  p: 'mt-4',
  strong: 'font-black',
  a: 'text-blue-600 underline hover:text-blue-700',
};

const bindings = Object.keys(classMap).map((key) => ({
  type: 'output',
  regex: new RegExp(`<${key}(.*)>`, 'g'),
  replace: `<${key} class="${classMap[key]}" $1>`,
}));

const defaultConverter = new Converter({
  extensions: [...bindings],
});

export function Content({ converter, className, children }) {
  return <HTMLContent className={className} content={(converter || defaultConverter).makeHtml(children)} />;
}

Content.propTypes = {
  converter: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
};

Content.defaultProps = {
  converter: null,
  className: '',
  children: null,
};
